import classNames from 'classnames';
import type { ComponentPropsWithoutRef, ReactNode, Ref } from 'react';

import { BadgeVariant } from './types';

import styles from './Badge.module.scss';

export function Badge({
    children,
    className,
    iconLeft: IconLeft,
    iconRight: IconRight,
    innerRef,
    variant = 'indigo-light',
    ...props
}: Badge.Props) {
    return (
        <span
            className={classNames(styles.badge, className, {
                // variants
                [styles.indigoLight]: variant === 'indigo-light',
                [styles.red]: variant === 'red',
                [styles.white]: variant === 'white',
            })}
            ref={innerRef}
            {...props}
        >
            {IconLeft && <IconLeft className={classNames(styles.icon, styles.iconLeft)} />}
            {children}
            {IconRight && <IconRight className={classNames(styles.icon, styles.iconRight)} />}
        </span>
    );
}
export namespace Badge {
    export interface Props extends ComponentPropsWithoutRef<'div'> {
        iconLeft?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
        iconRight?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
        innerRef?: Ref<HTMLDivElement>;
        variant?: `${BadgeVariant}`;
        children: ReactNode;
    }
    export type Variant = BadgeVariant;
    export const Variant = BadgeVariant;
}
